export const HamburguerIcon = (props: any) => (
  <svg
    width="22"
    height="8"
    viewBox="0 0 22 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M21 1.10156H1" stroke="#1F2D27" strokeLinecap="round" />
    <path d="M21 7.10547H7" stroke="#1F2D27" strokeLinecap="round" />
  </svg>
);
